import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { RegularExpressionPattern } from '@shared/_constants';

export const SPECIAL_KEYS = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'];
export const INT_MAX_LENGTH = 16;
export const INT_MAX_VALUE = 9223372036854775807n;

@Directive({
  selector: '[appNoDecimals]',
})
export class NoDecimalsDirective {
  @Input() set appNoDecimals(value) {
    if (value !== null && value !== undefined && value !== '') {
      this._noDecimals = value;
    }
  }

  private _noDecimals = true;

  // one dot allowed patttern
  private regexDecimalsAllowed = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g); //new RegExp(RegularExpressionPattern.NumberWithDecimalPattern); //
  private regex = new RegExp(RegularExpressionPattern.NumberPattern);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = SPECIAL_KEYS;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return true;
    }

    if (event.ctrlKey === true && ['C', 'c', 'V', 'v', 'X', 'x', 'A', 'a'].indexOf(event.key) !== -1) {
      return true;
    }

    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    const current: string = this.el.nativeElement.value;
    // We need this because the current value on the DOM element
    // is not yet updated with the value from this event

    const _regex = this._noDecimals ? this.regex : this.regexDecimalsAllowed;

    const next: string = current.concat(event.key);

    // to check max length for type int
    let isMaxLengthReached = false;
    let isMaxValueReached = false;

    if (this._noDecimals && next.length > INT_MAX_LENGTH) {
      isMaxLengthReached = true;
    } else if (this._noDecimals && parseInt(next) > INT_MAX_VALUE) {
      isMaxValueReached = true;
    }

    if ((next && !String(next).match(_regex)) || isMaxLengthReached || isMaxValueReached) {
      event.preventDefault();
    }
    return true;
  }
}
